import { useMemo } from 'react'

import { DEVICE_TYPES, DeviceTypeValue } from '@constants/deviceTypes'
import useIsMobile from '@hooks/useIsMobile'
import useIsTablet from '@hooks/useIsTablet'

const useDeviceType = (): DeviceTypeValue => {
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()

  return useMemo(() => {
    if (isMobile) {
      return DEVICE_TYPES.MOBILE
    } else if (isTablet) {
      return DEVICE_TYPES.TABLET
    } else {
      return DEVICE_TYPES.DESKTOP
    }
  }, [isMobile, isTablet])
}

export default useDeviceType
